import classNames from "classnames";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";

export const SSRTypeSelectionSkeleton = ({ block }: { block?: boolean }) => (
  <div className={classNames("flex gap-2 rounded-full border border-border-default bg-background-default p-2", block ? "w-full" : "w-min")}>
    {[0, 1, 2].map((i) => (
      <SkeletonBox key={i} className={classNames("h-8 rounded-full", block ? "flex-1" : "w-24 md:w-28")} />
    ))}
  </div>
);

export const FlightSelectionSkeleton = () => (
  <div className="flex w-full flex-col gap-4">
    <div className="flex w-full items-end justify-between gap-2">
      <div className="flex flex-col gap-1">
        <SkeletonBox className="h-5 w-20" />
        <SkeletonBox className="h-7 w-40 md:h-8" />
      </div>
      <SkeletonBox className="h-4 w-20" />
    </div>
    <div className="border-t border-border-subtle" />
  </div>
);

export const PassengerTileSkeleton = () => (
  <div className="flex w-full items-center gap-4">
    <SkeletonBox className="h-10 w-10 shrink-0 rounded-full" />
    <div className="flex w-full flex-1 items-start justify-between gap-1">
      <div className="flex flex-col gap-1">
        <SkeletonBox className="h-5 w-32" />
        <SkeletonBox className="h-3 w-14" />
      </div>
      <SkeletonBox className="h-4 w-16" />
    </div>
  </div>
);

export const DisclaimersSkeleton = () => (
  <div className="flex w-full flex-col gap-2 rounded-md border border-border-active bg-background-default p-4">
    <div className="flex items-center gap-2">
      <SkeletonBox className="h-5 w-5 rounded-full" />
      <SkeletonBox className="h-5 w-28" />
    </div>
    <div className="flex flex-col gap-2 ps-5">
      <SkeletonBox className="h-4 w-full" />
      <SkeletonBox className="h-4 w-5/6" />
      <SkeletonBox className="h-4 w-2/3" />
    </div>
  </div>
);
